import { useEffect } from "react";
import { motion } from "framer-motion";
import Navbar from "./Navbar";
import Footer from "./Footer";

const ease = [0.16, 1, 0.3, 1];

export function Section({ title, children }) {
  return (
    <div className="mt-10">
      {title && <h3 className="font-editorial text-xl md:text-2xl tracking-tight text-navy mb-3">{title}</h3>}
      <div className="space-y-3 text-navy/70 leading-relaxed text-[15px]">{children}</div>
    </div>
  );
}

export function Bullets({ items }) {
  return (
    <ul className="space-y-2 pl-1">
      {items.map((it, i) => (
        <li key={i} className="flex gap-3">
          <span className="mt-2 w-1.5 h-1.5 rounded-full bg-violet shrink-0" />
          <span>{it}</span>
        </li>
      ))}
    </ul>
  );
}

export default function LegalLayout({ eyebrow, title, updated, children, testid }) {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="min-h-screen bg-cream" data-testid={testid}>
      <Navbar />
      <main className="max-w-3xl mx-auto px-6 lg:px-8 pt-36 pb-24">
        <motion.header initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, ease }}>
          {eyebrow && <div className="overline text-navy/40 mb-3">{eyebrow}</div>}
          <h1 className="font-editorial text-4xl md:text-5xl tracking-tight text-navy leading-tight">{title}</h1>
          {updated && <p className="mt-4 text-sm text-navy/45">{updated}</p>}
        </motion.header>
        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, ease, delay: 0.1 }}
          className="mt-6 border-t border-navy/10 pt-2">
          {children}
        </motion.div>
      </main>
      <Footer />
    </div>
  );
}
